// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import i18n from '@/plugins/i18n'
import axios from 'axios';
import moment from 'moment';
// import VueFbCustomerChat from 'vue-fb-customer-chat'

// Vue.use(VueFbCustomerChat, {
//   page_id: '117562018294730', //  change 'null' to your Facebook Page ID,
//   theme_color: '#333333', // theme color in HEX
//   locale: 'fr_CA', // default 'en_US'
// })


Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY hh:mm')
  }
})
Vue.filter('fromNowDate', function (value) {
  if (value) {
    return moment(String(value)).fromNow()
  }
})

Vue.config.productionTip = false
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.component('appt-button', require('./components/buttons/ApptButton.vue').default)

Vue.prototype.$http = axios;
const token = localStorage.getItem('token');
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = "Token " + token;
}
Vue.prototype.$http.defaults.baseURL = process.env.BASE_URL;
Vue.prototype.$http.defaults.headers.get['Accepts'] = 'application/json';
Vue.prototype.$http.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
Vue.prototype.$http.defaults.headers.common['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept, X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token'

const prod = process.env.NODE_ENV === 'production'
const shouldSW = 'serviceWorker' in navigator && prod
if (shouldSW) {
  navigator.serviceWorker.register('/service-worker.js').then(() => {
    console.log("Service Worker Registered!")
  })
}

// console.log('env', JSON.stringify(process.env))
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  i18n,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js